
import { atom } from 'jotai'
import { mobileWidth } from '../constants';

// atoms are like global state variables
const priceAtom = atom(10)
const messageAtom = atom('hello')
const productAtom = atom({ id: 12, name: 'good stuff' })
const textAtom = atom('hello')
const isSmallAtom = atom(false); //window.innerWidth < mobileWidth);
const isLandscapeAtom = atom(true);
const isShowingMobileMenuAtom = atom(false);
const titleAtom = atom('Introduction')
const slideIndexAtom = atom(0)
const audioPlayingAtom = atom(false)
const audioFileAtom = atom('') // this wont work by default without sound include
const videoPlayingAtom = atom(false)
const isThreeFlagLoadingAtom = atom(true)
const isLandscapePopupAtom = atom(0)
const preloadedAssetsAtom = atom([])
const isShowingHelpAtom = atom(false); //window.innerWidth < mobileWidth);
const isOptionsOpenAtom = atom(false);
const isContrastAtom = atom(false);
const isAnimationsPausedAtom = atom(false);

export {
    priceAtom,
    messageAtom,
    productAtom,
    textAtom,
    isSmallAtom,
    isLandscapeAtom,
    titleAtom,
    isShowingMobileMenuAtom,
    slideIndexAtom,
    audioPlayingAtom,
    audioFileAtom,
    videoPlayingAtom,
    isThreeFlagLoadingAtom,
    isLandscapePopupAtom,
    preloadedAssetsAtom,
    isShowingHelpAtom,
    isOptionsOpenAtom,
    isContrastAtom,
    isAnimationsPausedAtom
}